import { createFileRoute } from '@tanstack/react-router';
import { HalloweenExperience } from '@/components/halloween/HalloweenExperience';
export const Route = createFileRoute('/halloween')({
 head: () => ({ meta: [
  { title: 'Halloween Special: The Mansion of Forgotten Shadows — Recovery Trauma™' },
  { name: 'description', content: "Enter Recovery Trauma™'s Halloween mansion: a fictional Ouija-style board, gentle reflection cards and a candlelit adventure at your own pace." },
  { property: 'og:title', content: 'Halloween Special — Recovery Trauma™' },
  { property: 'og:description', content: 'A candlelit Halloween adventure with optional journaling and self-compassion. Fictional storytelling, never spirit communication.' },
  { property: 'og:type', content: 'website' },
  { name: 'twitter:card', content: 'summary_large_image' },
 ] }), component: HalloweenExperience,
});
